import { render, staticRenderFns } from "./SmsDetailModel.vue?vue&type=template&id=106d36dd&"
import script from "./SmsDetailModel.vue?vue&type=script&lang=js&"
export * from "./SmsDetailModel.vue?vue&type=script&lang=js&"
import style0 from "./SmsDetailModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports